let accessToken = null;
let refreshToken = null;

export function getAccessToken() {
  return accessToken;
}

export function getRefreshToken() {
  return refreshToken;
}

export function setTokens(nextAccessToken, nextRefreshToken) {
  accessToken = nextAccessToken || null;
  refreshToken = nextRefreshToken || null;
}

export function clearTokens() {
  accessToken = null;
  refreshToken = null;
}
